import { vFactsConstants } from '../constants';

export function vFacts(state = {}, action) {
  switch (action.type) {
    case vFactsConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case vFactsConstants.GETALL_SUCCESS:
      return {
        items: action.vFacts
      };
    case vFactsConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
